// ClimatologySnowMeltForm.jsx
import "../../css/DemoCode.css"

/**
 * Frame for Climatology Snow Melt inputs
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @returns UI for interactive swmm modeling.
 */
export default function ClimatologySnowMeltForm({model, setModel}) {
  // When there is a change to an input element, modify the model.
  const updateValue = (val, type) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ""
    if(model && model.TEMPERATURE){

      setModel(prev => ({
        ...prev,
        TEMPERATURE:{
          ...prev.TEMPERATURE,
          SNOWMELT: {
            ...prev.TEMPERATURE.SNOWMELT,
            [type]: val
          }
        }
      }))
    }
  }

  return(
    <>
    {
      model.TEMPERATURE &&
      model.TEMPERATURE.SNOWMELT &&
      <>
      <label className='editor-small' >Dividing Temperature Between Snow and Rain
        <input  type = "number"
                style={{width: '95%', display: 'flex'}}
                onChange={(e)=>{updateValue(e.target.value, 'DivideTemp')}}
                value={model.TEMPERATURE.SNOWMELT.DivideTemp}
                id={'ClimatologySnowMeltDivideTemp'}
        />
      </label>
      <label className='editor-small' >ATI Weight (fraction)
        <input  type = "number"
                style={{width: '95%', display: 'flex'}}
                onChange={(e)=>{updateValue(e.target.value, 'ATIWeight')}}
                value={model.TEMPERATURE.SNOWMELT.ATIWeight}
                id={'ClimatologySnowMeltATIWeight'}
        />
      </label>
      <label className='editor-small' >Negative Melt Ratio (fraction)
        <input  type = "number"
                style={{width: '95%', display: 'flex'}}
                onChange={(e)=>{updateValue(e.target.value, 'NegMeltRatio')}}
                value={model.TEMPERATURE.SNOWMELT.NegMeltRatio}
                id={'ClimatologySnowMeltNegMeltRatio'}
        />
      </label>
      <label className='editor-small' >Elevation above MSL
        <input  type = "number"
                style={{width: '95%', display: 'flex'}}
                onChange={(e)=>{updateValue(e.target.value, 'MSLElev')}}
                value={model.TEMPERATURE.SNOWMELT.MSLElev}
                id={'ClimatologySnowMeltMSLElev'}
        />
      </label>
      <label className='editor-small' >Latitude (degrees)
        <input  type = "number"
                style={{width: '95%', display: 'flex'}}
                onChange={(e)=>{updateValue(e.target.value, 'DegLatitude')}}
                value={model.TEMPERATURE.SNOWMELT.DegLatitude}
                id={'ClimatologySnowMeltDegLatitude'}
        />
      </label>
      <label className='editor-small' >Longitude Correction (+/- minutes)
        <input  type = "number"
                style={{width: '95%', display: 'flex'}}
                onChange={(e)=>{updateValue(e.target.value, 'LongCorrection')}}
                value={model.TEMPERATURE.SNOWMELT.LongCorrection}
                id={'ClimatologySnowMeltLongCorrection'}
        />
      </label>
      </>
    }
    </>
  )
}